<template>
  <b-row>
    <b-col md="6"  lg="6" xl="4" class="col-xxl-3">
      <b-form-group class="mb-0" label="Que tenham">
        <multiselect v-model="value.type" :multiple="false" label="label" @select="updateValues"  :options="typeOptions"></multiselect>
      </b-form-group>
    </b-col>
    <b-col md="4"  lg="4" xl="4" class="col-xxl-3" v-if="value.type != null">
      <b-form-group class="mb-0" label="Um dos seguintes">
          <multiselect v-model="selectedValues" track-by="value" :multiple="true" label="text" @select="updatedCondition"   :options="conditionValues" :close-on-select="false"></multiselect>
      </b-form-group>
    </b-col>
    <b-col class="d-flex align-items-end" >
      <b-btn variant="danger" class="align-bottom" @click="removeSelf"><i class="fa fa-times"></i></b-btn>
    </b-col>
  </b-row>
</template>
<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: "ConditionForm",
  components: { Multiselect },
  props: {
    value: {
      type: Object,
      required: true,
    },
    recipienttype: {
      type: Number,
      required: true,
    },
    regions: {
      type: Array,
    },
    activities: {
      type: Array,
    },
    membertypes: {
      type: Array,
    },
  },
  data() {
    return {
      allSelected: false,
      indeterminate: false,
      conditionValues: [],
      selectedValues: [],
      oldType: '',
      familyOptions: [{
        label: 'Tenham membros nos escalões',
        value: 'membertypes'
      }, {
         label: 'Região',
        value: 'regions'
      }, {
         label: 'Tenham membros inscritos nas actividades',
        value: 'activities'
      }, {
         label: 'Tenham membros que tenham feito as actividades',
        value: 'history'
      }],
      personOptions: [{
        label: 'Escalão',
        value: 'membertypes'
      }, {
         label: 'Região',
        value: 'regions'
      }, {
         label: 'Inscritos nas actividades',
        value: 'activities'
      }, {
         label: 'Que tenham feito actividades',
        value: 'history'
      }],
    };
  },
  watch: {
    value() {
      this.$emit("input", this.value);
    },
    selectedValues() {
      this.value.values = this.selectedValues
      this.$emit("input", this.value);
    },
  },
  computed: {
    typeOptions() {
      if(this.recipienttype == 1) {
        return this.familyOptions;
      }
      if(this.recipienttype == 2) {
        return this.personOptions;
      }
    }
  },
  methods: {
    removeSelf() {
      this.$emit("remove-condition")
    },
    updateValues(val) {
      if(val.value != this.oldType.value) {
        this.selectedValues = []
        this.oldType = val
      }
      // this.value.values = []
      if (val.value === "membertypes") {
        this.conditionValues = this.membertypes.map((item) => ({
          text: item.text,
          value: item.value,
        }));
      } else if (val.value === "activities") {
        this.conditionValues = this.activities.map((item) => ({
          text: item.text,
          value: item.value,
        }));
      } else if (val.value === "history") {
        this.conditionValues = this.activities.map((item) => ({
          text: item.text,
          value: item.value,
        }));
      } else if (val.value === "regions") {
        this.conditionValues = this.regions.map((item) => ({
          text: item.text,
          value: item.value,
        }));
      } else {
        this.conditionValues = []
      }

    },
    updatedCondition(val) {
      console.log('condition component: changed conditions')
      this.$emit("updated-condition")
    },
    toggleAll(checked) {
      console.log(this.conditionValues.slice());
      this.value.values = checked
        ? this.conditionValues.map((item) => item.value).slice()
        : [];
    },
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
  created() {
    if(this.value.type !== null) {
      this.oldType = this.value.type
      this.selectedValues = this.value.values
      this.updateValues(this.value.type)
    }
  }
};
</script>
